module.exports = "fonts/Twemoji_Mozilla/TwemojiMozilla-sbix.e8e92b5.woff2";